import React, { Fragment, Component, isValidElement } from 'react';
import { Route, NavLink } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import cn from 'classnames';

import WithScroll from 'hocs/WithScroll';
import { setPositionFixed } from 'helpers';
import NavList from 'components/NavList';
import SwitchWithRedirect from 'components/SwitchWithRedirect';
import TemplatesList from './components/TemplateList';
import { isNotLocalized } from './fn/utils';

class Templates extends Component {
  state = {
    isNavSticked: false,
    isNavOpened: false,
  };

  componentWillMount() {
    this.props.scroll.addListener('scroll', this.handleScrollToMore);
  }

  componentWillUnmount() {
    this.props.scroll.removeListener('scroll', this.handleScrollToMore);
  }

  handleScrollToMore = () => {
    const { top } = this.navRef.getBoundingClientRect();
    const { isNavSticked } = this.state;
    const shouldStick = top <= 0;

    if (isNavSticked === shouldStick) return;

    this.setState({ isNavSticked: top <= 0 });
  };

  handleNavListToggle = isOpened => {
    this.setState({ isNavOpened: isOpened });
  };

  render() {
    const { location, tabs, routes, templates } = this.props;
    const { isNavSticked, isNavOpened } = this.state;

    return (
      <Fragment>
        <section className="section section_templates_1">
          <div className="wrapper">
            <div className="section__header-wrap">
              <h2 className="section__title title_size_l _mb-18">
                Website templates localized for every business
              </h2>
              <div className="section__locale-toggler">
                <NavLink
                  to="/templates"
                  isActive={() => isNotLocalized(location)}
                  activeClassName="section__locale-toggler-active"
                >
                  Global
                </NavLink>
                <NavLink
                  to="/templates/localized"
                  activeClassName="section__locale-toggler-active"
                >
                  Localized
                </NavLink>
              </div>
            </div>
          </div>
        </section>
        <section
          className={cn('section section_templates_2', {
            'sticky-nav': isNavSticked,
            'sticky-nav--open': isNavOpened,
          })}
          ref={node => (this.navRef = node)}
        >
          {tabs.length !== 0 && isNotLocalized(location) && (
            <NavList
              tabs={tabs}
              root="templates"
              listClassName="tab-menu_templates"
              onToggle={this.handleNavListToggle}
            />
          )}
        </section>
        <div className="section__articles">
          <TransitionGroup>
            <CSSTransition
              key={location.key}
              classNames="fade"
              timeout={300}
              onExit={setPositionFixed}
            >
              <SwitchWithRedirect location={location}>
                {routes.map(({ path, tab, key }) => (
                  <Route path={path} key={key} exact={key === 0}>
                    <TemplatesList templates={templates[tab]} />
                  </Route>
                ))}
                <Route path="/templates/localized">
                  <TemplatesList templates={templates.localized} />
                </Route>
              </SwitchWithRedirect>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </Fragment>
    );
  }
}

export default WithScroll(Templates);
